module.exports = __webpack_public_path__ + "img/li.c10b9f03.svg";